import { translate } from '../i18n/messages';
import type { SelectOption } from '../components/ui';

export const environmentOptions: SelectOption[] = [
  { label: 'prod', value: 'prod' },
  { label: 'stage', value: 'stage' },
  { label: 'dev', value: 'dev' },
  { label: 'local', value: 'local' },
];

export const applicationStatusOptions: SelectOption[] = [
  { label: '', labelKey: 'billing.ui.active', value: 'active' },
  { label: '', labelKey: 'billing.status.disabled', value: 'disabled' },
];

export const webhookStatusOptions: SelectOption[] = [
  { label: '', labelKey: 'billing.ui.active', value: 'active' },
  { label: '', labelKey: 'billing.status.disabled', value: 'disabled' },
];

export const credentialStatusOptions: SelectOption[] = [
  { label: '', labelKey: 'billing.ui.active', value: 'active' },
  { label: '', labelKey: 'billing.status.disabled', value: 'disabled' },
];

export const credentialScopeOptions = [
  'billing.read',
  'billing.customer.resolve',
  'billing.subscription.read',
  'billing.subscription.write',
  'billing.checkout.write',
] as const;

export const productStatusOptions: SelectOption[] = [
  { label: '', labelKey: 'billing.ui.draft', value: 'draft' },
  { label: '', labelKey: 'billing.ui.active', value: 'active' },
  { label: '', labelKey: 'billing.ui.archived', value: 'archived' },
];

export const productVisibilityOptions: SelectOption[] = [
  { label: '', labelKey: 'billing.ui.public', value: 'public' },
  { label: '', labelKey: 'billing.ui.private', value: 'hidden' },
  { label: '', labelKey: 'billing.ui.internal', value: 'internal' },
];

export const productTypeOptions: SelectOption[] = [
  { label: '', labelKey: 'billing.ui.subscription', value: 'subscription' },
  { label: '', labelKey: 'billing.ui.internal', value: 'internal' },
];

export const priceStatusOptions: SelectOption[] = [
  { label: '', labelKey: 'billing.ui.draft', value: 'draft' },
  { label: '', labelKey: 'billing.ui.active', value: 'active' },
  { label: '', labelKey: 'billing.ui.archived', value: 'archived' },
];

export const billingIntervalOptions: SelectOption[] = [
  { label: '', labelKey: 'billing.ui.none', value: 'none' },
  { label: '', labelKey: 'billing.ui.monthly', value: 'month' },
  { label: '', labelKey: 'billing.ui.yearly', value: 'year' },
];

export const currencyOptions: SelectOption[] = [
  { label: 'USD', value: 'USD' },
  { label: 'EUR', value: 'EUR' },
];

export const providerCapabilityStatusOptions: SelectOption[] = [
  { label: '', labelKey: 'billing.ui.supported', value: 'supported' },
  { label: '', labelKey: 'billing.ui.partial', value: 'partial' },
  { label: '', labelKey: 'billing.ui.unsupported', value: 'unsupported' },
];

export function optionLabel(options: SelectOption[], value: string | null | undefined) {
  const option = options.find((option) => option.value === value);
  return option?.labelKey ? translate(option.labelKey) : (option?.label ?? (value || '—'));
}
